export const SliceConstants = {
  GetContacts: 'getContacts',
};
